import { LoyaltyUserInfo } from "components/organisms/LoyaltyUserInfo";
import { FC } from "react";
import { useGetUserMascots } from "../../queries/useGetUserMascots";

type LoyaltyUserInfoContainerProps = {
  className?: string;
};

const LoyaltyUserInfoContainer: FC<LoyaltyUserInfoContainerProps> = ({
  className,
}) => {
  const { data: mascotsUser, isLoading } = useGetUserMascots();

  const activeMascot =
    mascotsUser?.data?.data?.find((mascot) => mascot.status === "active") ||
    null;

  return (
    <LoyaltyUserInfo
      avatar={activeMascot?.link}
      className={className}
      isLoading={isLoading}
    />
  );
};

export default LoyaltyUserInfoContainer;
